import React from 'react';
import styles from './ListBtn.module.css';
import { ListSvg } from '../../SVGComponents/SVGComponents';

export default function ListBtn() {
  return (
    <button className={styles.list_btn}>
      <ListSvg />
    </button>
  );
}
